<template>
    <div
        :class="{active: isActive}"
        class="tab-wrapper"
        @click="$emit('update:modelValue', name)">
        <div class="btn-wrapper">
            <button
                :aria-label="label"
                :class="{active: isActive}"
                class="btn btn-sm btn-outline-primary btn-square"
                type="button">
                <slot name="icon">
                    <font-awesome-icon
                        :icon="icon"
                        size="2x" />
                </slot>
            </button>
        </div>
        <div class="slide-label-wrapper">
            <div class="slide-label rounded bg-primary text-white">
                <slot name="label">
                    <span>{{ label }}</span>
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AwesomeTab",
    props: {
        modelValue: {
            required: true
        },
        label: {
            type: String,
        },
        icon: {
            type: [Object, Array, String]
        },
        name: {
            required: true,
            type: String
        }
    },
    computed: {
        isActive() {
            return this.modelValue === this.name
        }
    }
}
</script>

<style lang="scss" scoped>

$button-size: 3.25rem;

.tab-wrapper {
    position: relative;
    display: flex;
    align-items: stretch;
    height: $button-size;

    .btn-wrapper {
        position: relative;
        z-index: 2;
        background-color: $white;

        .btn-square {
            height: $button-size;
            width: $button-size;
        }
    }

    .slide-label-wrapper {
        cursor: pointer;
        z-index: 1;
        position: relative;
        display: flex;
        align-items: center;

        .slide-label {
            overflow: hidden;
            white-space: nowrap;
            max-width: 0;
            margin-left: -$button-size;
            transition: all 0.5s;

            padding: $btn-padding-y-sm $btn-padding-x-sm $btn-padding-y-sm $btn-padding-x-sm * 1.3;
            letter-spacing: $btn-letter-spacing;
            font-size: $input-btn-font-size;
        }
    }

    &:hover, &.active {
        .slide-label-wrapper {
            .slide-label {
                max-width: 200px;
                margin-left: -5px;
            }

        }
    }
}
</style>
